export default __webpack_public_path__ + "static/desk-property02-61345bbbdd09319cedf4638d8b60ed86.jpg";